import { DEFAULT_SEARCH_PROVIDER } from '@lib/constants';
import { CURRENCY } from '@lib/constants/variants';
import { useStore } from '@lib/context/store-context';
import { validateLoginBuyer } from '@lib/data/validate-login-buyer';
import { trackBeginCheckout } from '@lib/util/google-analytics-utils';
import { toaster } from '@lib/util/toaster';
import { BusinessInfo } from 'types/business';

type onSubmitProps = {
  business: BusinessInfo;
  values: any;
  addItem: ReturnType<typeof useStore>['addItem'];
  cart: any;
  customer: any;
  setLoading: (loading: boolean) => void;
  setIsOptedOut: (isOptedOut: boolean) => void;
  setIsClickSubmit: (isClickSubmit: boolean) => void;
  isTextMethod: boolean;
};

export const onSubmit = async (props: onSubmitProps) => {
  const { business, values, addItem, cart, customer, setLoading, setIsOptedOut, setIsClickSubmit, isTextMethod } = props;
  const currentDollarValue = values?.variant?.price || values?.variant?.prices;
  const { isValid, errorMessage } = await validateLoginBuyer(cart?.id, customer?.email, customer?.phone, values.quantity, currentDollarValue);

  if (!isValid) {
    setLoading(false);
    toaster.error(<div dangerouslySetInnerHTML={{ __html: errorMessage }} />);
    return;
  }

  trackBeginCheckout({
    value: currentDollarValue / 100,
    currency: CURRENCY,
    items: [
      {
        item_name: `${currentDollarValue / 100} ${business.name} Gift Card`,
        price: currentDollarValue / 100
      }
    ]
  });

  addItem({
    variantId: values.variant.id,
    quantity: values.quantity,
    metadata: {
      variant_id: values.variant.id,
      relationship: values.relationship,
      occasion: values.occasion,
      business_external_id: business.id,
      business_name: business.name,
      business_alias: business.alias,
      photo_img_url: business.image_url,
      review_count: business.review_count,
      rating: business.rating,
      price: values.variant.price || currentDollarValue,
      url: business.url,
      delivery_date: values.deliveryDate,
      city: business?.location?.city,
      parent_category: business?.parent_category,
      card_program: business?.card_program,
      search_provider: business?.search_provider || DEFAULT_SEARCH_PROVIDER,
      author_display_name: business?.author_display_name,
    },
  });
};
